import { useEffect, useState } from 'react';
import { BrandModel } from '../../../models/brand';
import axios from '../../../lib/axios';
import { DELETE_BRAND, FIND_MANY_BRAND } from '../../../lib/endpoints/brand';

const useBrandController = () => {
  const [brandData, setBrandData] = useState<BrandModel[]>([]);
  const [selectedBrand, setSelectedBrand] = useState<BrandModel>(null!);
  const [selectedId, setSelectedId] = useState<string>(null!);

  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [loadingButton, setLoadingButton] = useState<boolean>(false);

  const [currentPage, setCurrentPage] = useState<number>(1);

  const [searchValue, setSearchValue] = useState<string>('');

  const [openMenu, setOpenMenu] = useState(null);
  const [openForm, setOpenForm] = useState<boolean>(false);
  const [openDeleteForm, setOpenDeleteForm] = useState<boolean>(false);

  // ------------- Api Manage------------//

  const handleFetchData = async () => {
    try {
      setLoadingData(true);
      const res = await axios.post(FIND_MANY_BRAND);
      setBrandData(res?.data);
    } catch (err) {
      // console.log(err);
    } finally {
      setLoadingData(false);
    }
  };

  const handleDeleteBrand = async () => {
    try {
      setOpenMenu(null);
      setLoadingButton(true);
      await axios.delete(DELETE_BRAND + selectedId);
      await handleFetchData();
      setOpenDeleteForm(false);
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert('Server error please try again');
      }
    } finally {
      setLoadingButton(false);
    }
  };

  //------------- function -------------//

  const handleOpenForm = () => {
    setOpenForm(true);
  };

  const handleOpenEditForm = () => {
    const getData = brandData.filter((item: BrandModel) => item?.id === selectedId)[0];
    setSelectedBrand(getData);
    setOpenForm(true);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    setOpenMenu(null);
  };

  const handleOpenDeleteForm = () => {
    setOpenDeleteForm(true);
  };

  const handleCloseDeleteForm = () => {
    setOpenDeleteForm(false);
  };

  const handleChangePage = (event: any, newPage: any) => {
    setCurrentPage(newPage);
  };

  const handleSearchValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
    // setCurrentPage(1);
  };

  const handleOpenMenu = (event: any, getId: string) => {
    setOpenMenu(event.currentTarget);
    setSelectedId(getId);
  };

  const handleCloseMenu = () => {
    setOpenMenu(null);
  };

  const filterData = brandData.filter(
    (item) =>
      item?.nameLa?.toLowerCase()?.includes(searchValue?.toLowerCase()) ||
      item?.nameEn?.toLowerCase()?.includes(searchValue?.toLowerCase())
  );

  const rows: BrandModel[] = filterData?.slice((currentPage - 1) * 10, currentPage * 10);

  const countPagination = Math.ceil(filterData.length / 10);

  const isSearchNotFound = !filterData.length && !!searchValue;

  // ------------ useEffect ----------- //

  useEffect(() => {
    handleFetchData();
  }, []);

  return {
    rows,
    countPagination,
    handleChangePage,
    currentPage,
    handleOpenMenu,
    handleCloseMenu,
    openMenu,
    isSearchNotFound,
    handleSearchValue,
    loadingData,
    handleOpenForm,
    handleCloseForm,
    openForm,
    handleOpenDeleteForm,
    handleCloseDeleteForm,
    openDeleteForm,
    handleDeleteBrand,
    loadingButton,
    handleOpenEditForm,
    selectedBrand,
    setSelectedBrand,
    handleFetchData,
    searchValue,
  };
};
export default useBrandController;
